"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgApplication = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#fff", fillOpacity: 0.48, fillRule: "evenodd", d: "M3.982 6.214c0-.409.333-.74.744-.74h22.548c.41 0 .744.331.744.74V8.68H3.982zM2 9.668V6.214A2.72 2.72 0 0 1 4.726 3.5h22.548A2.72 2.72 0 0 1 30 6.214v19.572a2.72 2.72 0 0 1-2.726 2.714H4.726A2.72 2.72 0 0 1 2 25.786zm26.018.987v15.131c0 .409-.333.74-.744.74H4.726a.74.74 0 0 1-.744-.74V10.655z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M14.652 15.753q-.002 0-.004.002l-.003.003-1.458 4.073v.004c-.156.428-.393.788-.685 1.04s-.63.387-.973.39H6.708c-.342 0-.62-.387-.62-.864 0-.476.278-.863.62-.863h4.816a.5.5 0 0 0 .326-.131.83.83 0 0 0 .229-.349l1.462-4.085.005-.015c.113-.3.286-.547.498-.712a.97.97 0 0 1 .697-.215c.242.024.475.146.668.352.193.205.339.485.42.804l.003.013 1.526 6.359 1.47-4.084.001-.003c.153-.431.39-.794.684-1.048.294-.253.633-.387.979-.386l-.001.863v-.863h4.8c.343 0 .62.387.62.863 0 .477-.277.864-.62.864H20.49a.5.5 0 0 0-.323.128.8.8 0 0 0-.227.347l-.001.004-1.47 4.086-.555-.386.554.387c-.11.304-.28.556-.491.725a.97.97 0 0 1-.698.226 1.06 1.06 0 0 1-.671-.35 1.8 1.8 0 0 1-.42-.81l-.002-.007-1.526-6.355.585-.286-.588.274.003.012-.002-.004z", clipRule: "evenodd" }),
    React.createElement("ellipse", { cx: 25.493, cy: 7.073, fill: "#fff", rx: 0.971, ry: 0.967 }),
    React.createElement("ellipse", { cx: 22.649, cy: 7.073, fill: "#fff", rx: 0.971, ry: 0.967 })));
exports.default = SvgApplication;
